import api from "services/api";

// Get all departments
export const getDepartments = async () => {
  return api.get("/v1/api/departments/list");
};
// Update status
export const updateDepartmentStatus = async (departmentId, statusData) => {
  return api.put("/v1/api/departments/status", {
    id: departmentId,
    status: statusData,
  });
};
// Create new department
export const createDepartment = async (departmentData) => {
  return api.post("/v1/api/departments/create", departmentData);
};

// Update department
export const updateDepartment = async (departmentId, departmentData) => {
  return api.put(`/v1/api/departments/update/${departmentId}`, departmentData);
};
